import React from "react";
import { useNavigate } from "react-router-dom";
import "./style.css";
import { FormattedMessage, useIntl } from "react-intl";
import { useSelector, useDispatch } from "react-redux";
import { useState } from "react";
import Stepper from "../../classificator/stepper";
import ChooseTemplateAsk from "./chooseTemplate";
import { useEffect } from "react";
import FormBuilderAsk from "./formBuilder";
import AskEditFooter from "./footer";
import AskBuilderRecipients from "./recipients";
import ImgAskFeedback from "../../../assets/img/ask-feedback.svg";
import { Button, ConfirmAbortModal } from "@ts-digital/vrc";
import LoaderSimple from "../../general/loader";
import { getCategoryAsk } from "../../../store/actions/ask/surveys";
import {
  getTemplateDetailAsk,
  getTemplatesAsk
} from "../../../store/actions/ask/templates";
import { getDraftAsk } from "../../../store/actions/ask/drafts";
import { getAnswerAsk } from "../../../store/actions/ask/index";
import { displayWarningToast } from "../../../store/actions/overflowNotification";
import CommunityTemplates from "./dots/communityTemplates";
import { FEATURE_TOGGLE_DOTS } from "../../../config";
import { useLocation } from "react-router-dom";

const defBodyRequest = {
  title: "",
  category: "",
  items: [],
  isShared: false,
  isPublic: false
};

const AskEditPage = props => {
  const {    
    result,
    saveAsk,
    pageRef
  } = props;

  const navigate = useNavigate();  
  const dispatch = useDispatch();
  const location = useLocation();
  const templates = useSelector(state => state.ask.templates);
  const surveys = useSelector(state => state.ask.templates);
  const drafts = useSelector(state => state.ask.drafts);

  const [stepNumber, setStepNumber] = useState(0);
  // const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [bodyRequest, setBodyRequest] = useState(defBodyRequest);
  const [draftId, setDraftId] = useState(null);
  const [confirmCancel, setConfirmCancel] = useState(false);
  // const [answerId, setAnswerId] = useState(null);
  const [isDraft, setIsDraft] = useState(null);
  const [preview, setPreview] = useState(null);
  const [recipients, setRecipients] = useState([]);
  const [recipientsUuid, setRecipientsUuid] = useState([]);
  const [error, setError] = useState("none");

  const intl = useIntl();

  const steps = [
    {
      number: 1,
      title: useIntl().formatMessage({ id: "ask.pages.edit.steps.step2" })
    },
    {
      number: 2,
      title: useIntl().formatMessage({ id: "ask.pages.edit.steps.step3" })
    },
    {
      number: 3,
      title: useIntl().formatMessage({ id: "ask.pages.edit.steps.step4" })
    }
  ];

  /** Ho passato a number per avere più performance: 1 = ok_template, 2 = ok */
  const message1 = useIntl().formatMessage({
    id:
      result === 1
        ? "ask.feedback.okTemplate1"
        : "ask.feedback.ok1"
  });

  const message2 = useIntl().formatMessage({
    id:
      result === 1
        ? "ask.feedback.okTemplate2"
        : `ask.feedback.ok2${isDraft ? "draft" : ""}`
  });

  const feedbackButton = useIntl().formatMessage({ id: "ask.feedback.button" });

  const convertItems = items => {
    let retItems = [];
    items.map(item => {
      return retItems.push({
        uuid: item.id,
        codiceFiscale: item.taxId,
        ragioneSociale: item.description
      });
    });
    return retItems;
  };

  useEffect(() => {
      
    dispatch(getTemplatesAsk());  
    
    if (location.search.indexOf("templateId=") > -1) {
      // setSelectedTemplate(location.search.split("templateId=")[1]);
      setStepNumber(0);
      dispatch(getTemplateDetailAsk(location.search.split("templateId=")[1])).then(res => {
        callbackGetterSetter(
          res.items,
          res.title + " " + intl.formatMessage({ id: "generic.copy" }),
          recipientsUuid,
          res.isShared === true ? true : false,
          res.isShared === true ? true : false,
          res.categoryId
        );
      });
    } else if (location.search.indexOf("draftId=") > -1) {
      setDraftId(location.search.split("draftId=")[1]);
      // setSelectedTemplate(location.search.split("draftId=")[1]);
      setStepNumber(1);
      dispatch(getDraftAsk(location.search.split("draftId=")[1])).then(res => {
        callbackGetterSetter(
          res.template.items,
          res.template.title,
          convertItems(res.items) || [],
          res.isShared === true ? true : false,
          res.isShared === true ? true : false,
          res.template.categoryId
        );
      });
    } else {
      if (location.search.indexOf("answerId=") > -1) {
        // setAnswerId(location.search.split("answerId=")[1]);
        setStepNumber(1);
        dispatch(getAnswerAsk(location.search.split("answerId=")[1])).then(res => {
          callbackGetterSetter(
            res.items,
            res.title + " " + intl.formatMessage({ id: "generic.copy" }),
            recipientsUuid,
            res.isShared === true ? true : false,
            res.isShared === true ? true : false,
            res.categoryId
          );
        });
      }
    }
  }, [location.search]);

  useEffect(() => {
    if (stepNumber === 3) {
      setPreview(true);
    } else {
      setPreview(false);
    }

    if (stepNumber === 1) {
      dispatch(getCategoryAsk());
    }
    document.getElementById("dbx-main-container").scrollTop = 0;
  }, [stepNumber]);

  useEffect(() => {
    if (error === "items") {
      dispatch(displayWarningToast(intl.formatMessage({ id: "ask.builder.feedback.noQuestion" }),
        intl.formatMessage({ id: "generic.attention" })));
    }
    if (error === "title") {
      dispatch(displayWarningToast(intl.formatMessage({ id: "ask.builder.feedback.noTitle" }), intl.formatMessage({ id: "generic.attention" })));
    }
    if (error === "category") {
      dispatch(displayWarningToast(intl.formatMessage({ id: "ask.builder.feedback.noCategory" }),
        intl.formatMessage({ id: "generic.attention" })));
    }
    if (error === "emptyItems") {
      dispatch(displayWarningToast(intl.formatMessage({ id: "ask.builder.feedback.emptyQuestion" }), intl.formatMessage({ id: "generic.attention" })));
    }
  }, [error]);

  const onSave = draft => {
    if (draft) {
      setIsDraft(true);
    }
    saveAsk(
      bodyRequest.items,
      undefined,
      bodyRequest.title,
      recipientsUuid,
      bodyRequest.isPublic,
      bodyRequest.isShared || bodyRequest.isForDots,
      draft,
      draftId,
      bodyRequest.category,
      bodyRequest.isForDots
    );
  };

  const callbackGetterSetter = (
    arrayInput,
    title,
    recipients,
    isShared,
    isPublic,
    categoryId
  ) => {
    let newItems = [];
    let cn = 0;
    arrayInput.map(item => {
      cn++;
      let type = item.type;
      if (item.format === "date") {
        type = "date";
      }
      if (item.format === "currency") {
        type = "currency";
      }
      if (item.format === "number") {
        type = "number";
      }
      if (item.type === "file") {
        type = "file";
      }
      let itemToAdd = {
        ...item,
        id: cn,
        type: type,
        isRequired: item.required
      };
      delete itemToAdd.required;
      return newItems.push(itemToAdd);
    });
    setBodyRequest({
      items: newItems,
      title: title,
      isShared: isShared,
      isPublic: isPublic,
      category: categoryId
    });
    setRecipientsUuid(recipients);
    setRecipients(recipients.map(el => {
      return el;
    }));
  };

  if (result) {
    return (
      <div>
        <div className={"askEdit-root"}>
          <div className="askEdit-result-img">
            <img src={ImgAskFeedback} alt="" />
            <div>
              {message1}{" "}
              <strong>{bodyRequest.title}</strong>{" "}
              {message2}
            </div>
          </div>
          <div className="askEdit-result-button">
            <Button
              onClick={() => navigate("/ask-list")}
              size="small"
              kind="secondary"
            >
              {feedbackButton}
            </Button>
          </div>
        </div>
      </div>
    );
  }

  const onSelectedTemplate = templateId => {
    if (templateId) {
      dispatch(getTemplateDetailAsk(templateId)).then(res => {
        callbackGetterSetter(
          res.items,
          res.title + " Copia",
          recipients,
          res.isShared === true ? true : false,
          res.isShared === true ? true : false,
          res.categoryId
        );
        // setSelectedTemplate(templateId);
        setStepNumber(1);
      });
    } else {
      // setSelectedTemplate(0);
      setStepNumber(1);
    }
  };

  const clearPage = () => {
    setBodyRequest(defBodyRequest);
    setStepNumber(0);
  };

  return (
    <div>
      <div
        className="askEdit-root"
        style={{paddingTop: stepNumber !== 0 && 20}}
      >
        {stepNumber !== 0 &&
          <Stepper
            currentStep={stepNumber}
            setCurrentStep={stepNumber => setStepNumber(stepNumber)}
            steps={steps}
            readOnly
          ></Stepper>
        }
        {confirmCancel && (
          <ConfirmAbortModal
            visible={confirmCancel}
            title={<FormattedMessage id="ask.builder.cancelTitle" />}
            onAbort={() => setConfirmCancel(false)}
            onConfirm={() => {
              setConfirmCancel(false);
              clearPage();
            }}
            abortText={"No"}
            confirmText={"Si"}
          >
            <div style={{ padding: "30px 0" }}>
              <FormattedMessage id="ask.builder.cancelMessage" />
            </div>
          </ConfirmAbortModal>
        )}
        {stepNumber === 0 && (
          <ChooseTemplateAsk
            onSelection={templateId => onSelectedTemplate(templateId)}
          />
        )}
        {stepNumber === 1 && (
          <FormBuilderAsk
            error={error}
            onSetError={errorType => setError(errorType)}
            bodyRequest={bodyRequest}
            preview={preview}
            onFormChange={bodyRequest => setBodyRequest(bodyRequest)}
            isDots={false}
            isDotsPreview={false}
          />
        )}
        {stepNumber === 2 && (
          <AskBuilderRecipients
            pageRef={pageRef}
            isShared={bodyRequest.isShared}
            isForDots={bodyRequest.isForDots}
            recipients={recipients}
            onRecipientsChange={value => {
              setRecipients(value);
              setRecipientsUuid(value.map(el => {
                return el.uuid;
              }));
            }}
          />
        )}
        {((stepNumber === 3 &&
          (templates.isSavingTemplate || surveys.isSavingSurvey)) ||
          drafts.isSavingDraftsSurvey) && <LoaderSimple />}
        {stepNumber === 3 &&
          !templates.isSavingTemplate &&
          !surveys.isSavingSurvey && (
          <div className="askEdit-preview-title">
            <FormattedMessage id="ask.builder.previewTitle" />
          </div>
        )}
        {stepNumber === 3 &&
          !templates.isSavingTemplate &&
          !surveys.isSavingSurvey && (
          <div className="askEdit-preview-container">
            <FormBuilderAsk
              bodyRequest={bodyRequest}
              preview={preview}
              isDots={false}
              onFormChange={bodyRequest => setBodyRequest(bodyRequest)}
              isDotsPreview={false}
            />
            <AskBuilderRecipients
              readOnly
              recipients={recipients}
              onRecipientsChange={value => {
                setRecipients(value);
                setRecipientsUuid(value.map(el => el.uuid));
              }}
            />
          </div>
        )}
        {stepNumber !== 0 &&
          !result &&
          !templates.isSavingTemplate &&
          !surveys.isSavingSurvey && (
          <AskEditFooter
            bodyRequest={bodyRequest}
            onCancelClick={() => setConfirmCancel(true)}
            nextStep={() =>
              stepNumber < 3 ? setStepNumber(stepNumber + 1) : onSave()
            }
            prevStep={() => setStepNumber(stepNumber - 1)}
            currentStep={stepNumber}
            preview={preview}
            result={result}
            recipients={recipientsUuid}
            setPreview={value => setPreview(value)}
            onSave={isDraft => onSave(isDraft)}
            onSetError={errorType => setError(errorType || "none")}
          />
        )}
      </div>
      {stepNumber === 0 && FEATURE_TOGGLE_DOTS === "true" &&
        <div className="ask-edit-root ask-edit-community-templates">
          <CommunityTemplates />
        </div>
      }
    </div>
  );
};

export default AskEditPage;
